import { create } from 'zustand';
import { ApiUtils, RequestStrategyEnum } from '@shared/utils';
import { CardsApi, type GetAllStatementsResponse } from '@shared/api';

interface UseAllStatementsStore {
  loading: boolean;
  data: GetAllStatementsResponse[];
  error: string | null;
  getAllStatementsCard: (cardId: string, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useAllStatementsStore = create<UseAllStatementsStore>((set) => ({
  loading: false,
  data: [],
  error: null,

  getAllStatementsCard: ApiUtils.wrapperApi(async (cardId, signal) => {
    try {
      set({ loading: true, error: null });
      const result = await CardsApi.getAllStatementsCard(cardId, signal);
      set({ data: result || [], loading: false });
    } catch (error) {
      set({ loading: false, error: ApiUtils.getApiError(error) });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ loading: false, data: [], error: null }),
}));
